<template>
  <div v-if="response">
    <b-container fluid>
      <b-row>
        <b-col lg="2" md="4" sm="12">
          <b-form-group v-bind:id="'fob' + key" label="FOB:" v-bind:label-for="'input-fob' + key" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value" 
              v-bind:id="'input-fob' + key"
              v-model="response.fob"
              v-bind:plaintext="true"
              disabled
              ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col lg="3" md="4" sm="12">
          <b-form-group v-bind:id="'ref_no' + key" label="Reference Number:" v-bind:label-for="'input-ref_no' + key" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value" 
              v-bind:id="'input-ref_no' + key"
              v-model="response.ref_no"
              v-bind:plaintext="true"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col lg="3" md="4" sm="12">
          <b-form-group v-bind:id="'expiration_ts' + key" label="Expiration:" v-bind:label-for="'input-expiration_ts' + key" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value" 
              v-bind:id="'input-expiration_ts' + key"
              v-model="expiration_ts_label"
              v-bind:plaintext="true"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col lg="2" md="6" sm="12">
          <b-form-group v-bind:id="'order_minimum_cost' + key" label="Order Min:" v-bind:label-for="'input-order_minimum_cost' + key" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value" 
              v-bind:id="'input-order_minimum_cost' + key"
              v-model="order_minimum_cost_label"
              v-bind:plaintext="true"
              disabled
              ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col lg="2" md="6" sm="12">
          <b-form-group v-bind:id="'line_minimum_cost' + key" label="Line Min.:" v-bind:label-for="'input-line_minimum_cost' + key" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value" 
              v-bind:id="'input-line_minimum_cost' + key"
              v-model="line_minimum_cost_label"
              v-bind:plaintext="true"
              disabled
              ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <additional-cost-read 
            v-bind:response="response"
            v-bind:id="response.label"
          />
        </b-col>
      </b-row>


      <b-form-group v-for="(response_line, line_index) in response.lines" :key="response_line.id" label-class="quote-summary-label">
        <line-read
             class="quote-summary-value" 
          v-bind:response="response.lines[line_index]"
          v-bind:title="'Line ' + (line_index + 1)"
        />
      </b-form-group>



      <b-row >
        <b-col lg="6" md="8" sm="12">
          <b-form-group v-bind:id="'comments' + key" label="Comments:" v-bind:label-for="'input-comments' + key" label-class="quote-summary-label">
            <b-form-textarea
             class="quote-summary-value" 
              v-bind:id="'input-comments' + key"
              v-model="response.comments"
              v-bind:plaintext="true"
              rows="4"
              wrap="hard"
              disabled
              ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col lg="4" md="4" sm="12">
        </b-col>


        <b-col lg="2" md="12" sm="12" v-if="!hideEdit">
          <b-link class="btn btn-block btn-success" v-bind:href="'#/quotes/' + response.id + '/edit'" v-b-tooltip.hover.top.v-secondary
                :title="'This will void the current quote and submit a new quote'">Void and Resubmit</b-link>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import ReadLine from "./ReadLine";
import ReadAdditionalCost from "./ReadAdditionalCost";

export default {
  name: "quote-read",
  props: ["response", "hideEdit"],
  components: {
    "line-read": ReadLine,
    "additional-cost-read": ReadAdditionalCost
  },
  computed: {
    order_minimum_cost_label: function() {
      let label = "N/A";
      if (this.response.order_minimum_cost > 0){
        label = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(this.response.order_minimum_cost);
      }
      return label;
    },
    line_minimum_cost_label: function() {
      let label = "N/A";
      if (this.response.line_minimum_cost > 0){
        label = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(this.response.line_minimum_cost);
      }
      return label;
    },
    expiration_ts_label: function() {
      if (this.response.expiration_ts) {
        if (this.response.expiration_ts.toLocaleDateString) {
          return this.response.expiration_ts.toLocaleDateString(); 
        }
        return this.response.expiration_ts;
      }
      return ""
    },
    key: function() {
      return "_quote_line";
    }
  },
  mounted() {
     console.log(this.response);
  }
};
</script>
 
 <style scoped>
 .form-control-plaintext.form-control-sm {
   padding-left: 9px;
 }
 .form-group {
    margin-bottom: 0.2rem;
}
 </style>